module.exports = __webpack_public_path__ + "static/img/culture3.ecb08caf.png";